'use server'

import { apiRequest, ApiResponse } from '../request'

export type TriageUrgency = 'RED' | 'ORANGE' | 'YELLOW' | 'GREEN' | 'BLUE'

export interface Triage {
    id: number
    urgency: TriageUrgency
    chiefComplaint?: string
    symptoms?: string
    vitalSigns?: any
    bloodPressureSystolic?: number
    bloodPressureDiastolic?: number
    heartRate?: number
    respiratoryRate?: number
    temperature?: number
    oxygenSaturation?: number
    painLevel?: number
    weight?: number
    height?: number
    allergies?: string
    medications?: string
    medicalHistory?: string
    observations?: string
    triageAt: string
    clientId: number
    client?: {
        id: number
        name: string
        email?: string
        whatsAppNumber?: string
    }
    professionalId: number
    professional?: {
        id: number
        name: string
        registrationNumber?: string
    }
    companyId: number
    createdAt: string
    updatedAt: string
    metadata?: any
}

export interface CreateTriageData {
    urgency?: TriageUrgency
    chiefComplaint?: string
    symptoms?: string
    vitalSigns?: any
    bloodPressureSystolic?: number
    bloodPressureDiastolic?: number
    heartRate?: number
    respiratoryRate?: number
    temperature?: number
    oxygenSaturation?: number
    painLevel?: number
    weight?: number
    height?: number
    allergies?: string
    medications?: string
    medicalHistory?: string
    observations?: string
    clientId: number
    professionalId: number
    companyId: number
    metadata?: any
}

export interface UpdateTriageData extends Partial<CreateTriageData> {}

export async function getTriages(
    companyId?: number
): Promise<ApiResponse<Triage[]>> {
    const params = companyId ? { companyId } : {}
    return apiRequest<Triage[]>('triages', { params })
}

export async function getTriagesByCompany(
    companyId: number,
    params?: { page?: number; limit?: number; search?: string },
): Promise<ApiResponse<Triage[]>> {
    return apiRequest<Triage[]>(`triages/company/${companyId}`, {
        params: params ?? {},
    })
}

export async function getTriagesByClient(
    clientId: number
): Promise<ApiResponse<Triage[]>> {
    return apiRequest<Triage[]>(`triages/client/${clientId}`, {})
}

export async function getTriagesByUrgency(
    companyId: number,
    urgency: TriageUrgency
): Promise<ApiResponse<Triage[]>> {
    return apiRequest<Triage[]>(`triages/urgency/${urgency}`, {
        params: { companyId },
    })
}

export async function getTriageQueue(
    companyId: number
): Promise<ApiResponse<Triage[]>> {
    return apiRequest<Triage[]>(`triages/queue/${companyId}`, {})
}

export async function getTriage(id: number): Promise<ApiResponse<Triage>> {
    return apiRequest<Triage>(`triages/${id}`, {})
}

export async function createTriage(
    data: CreateTriageData
): Promise<ApiResponse<Triage>> {
    return apiRequest<Triage>('triages', { data }, 'post')
}

export async function updateTriage(
    id: number,
    data: UpdateTriageData
): Promise<ApiResponse<Triage>> {
    return apiRequest<Triage>(`triages/${id}`, { data }, 'patch')
}

export async function deleteTriage(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`triages/${id}`, {}, 'delete')
}

export const URGENCY_LABELS: Record<TriageUrgency, string> = {
    RED: 'Emergencia',
    ORANGE: 'Muito Urgente',
    YELLOW: 'Urgente',
    GREEN: 'Pouco Urgente',
    BLUE: 'Nao Urgente',
}

export const URGENCY_COLORS: Record<TriageUrgency, string> = {
    RED: 'bg-red-500',
    ORANGE: 'bg-orange-500',
    YELLOW: 'bg-yellow-500',
    GREEN: 'bg-green-500',
    BLUE: 'bg-blue-500',
}
